import { Box } from "@mui/material";
import IdeasView from "../PanelViews/IdeasView/IdeasView";
import ReportsView from "../PanelViews/ReportsView/ReportsView";
import "./PanelContent.scss";
import UnitsView from "../PanelViews/UnitsView/UnitsView";
import TempFileForModal from "../PanelViews/TempFileForModal";
import AreasView from "../PanelViews/AreasView/AreasView";
import CategoriesView from "../PanelViews/CategoriesView/CategoriesView";
import IdeaMenu from "./IdeasMenu/IdeaMenu";
import EditIdea from "./EditIdea/EditIdea";
import { useImperativeHandle, useRef, forwardRef } from "react";

interface PanelContentProps {
  menuToShow: string;
  updateContent: (menu: string) => void;
  onSend: (data: any) => void;
  selectedIdea: any;
}

const PanelContent = forwardRef(
  (
    { menuToShow, updateContent, onSend, selectedIdea }: PanelContentProps,
    ref
  ) => {
    const refChild = useRef<{ doSomething: () => void }>(null);

    useImperativeHandle(ref, () => ({
      save() {
        refChild.current?.doSomething();
      },
    }));

    return (
      <Box className="panelContent">
        {menuToShow === "ideas" && (
          <IdeasView updateContent={updateContent} onSend={onSend} />
        )}
        {menuToShow === "idea-details" && (
          <IdeaMenu selectedIdea={selectedIdea} />
        )}
        {menuToShow === "units" && <UnitsView />}
        {menuToShow === "areas" && <AreasView />}
        {menuToShow === "categories" && <CategoriesView />}
        {menuToShow === "users" && <TempFileForModal />}
        {menuToShow === "kpis" && <ReportsView />}
        {menuToShow === "edit-idea" && (
          <EditIdea
            selectedIdea={selectedIdea}
            updateContent={updateContent}
            onSend={onSend}
            ref={refChild}
          />
        )}
      </Box>
    );
  }
);

export default PanelContent;
